import { makeTypes, mac, asyncMac, createReducer, reduceReducers } from 'ducks-maker'
import { createFetch, editFetch, addFetch, selectHOR, removeErrorHOR } from './hors.js'
import { leer, modificar, crear } from '../services/api'

const t = makeTypes('clases')
const FETCH = t('fetch').async()
const EDIT = t('edit').async()
const ADD = t('add').async()
const SELECT = t('select').single()
const REMOVEERROR = t('removeError').single()

const fetchActions = asyncMac(FETCH)
const editActions = asyncMac(EDIT)
const addActions = asyncMac(ADD)
export const removeError = mac(REMOVEERROR)
export const selectClase = mac(SELECT,'payload')

const initialState = {
    data: [],
    fetched: false,
    fetching: false,
}

const fetchReducer = createReducer(initialState, createFetch( FETCH ))
const editReducer = createReducer(initialState, editFetch( EDIT ))
const addReducer = createReducer(initialState, addFetch( ADD ))
const removeErrorReducer= createReducer(initialState, removeErrorHOR({ REMOVEERROR }))
const selectReducer = createReducer(initialState, selectHOR({ SELECT }))

export default reduceReducers(fetchReducer, editReducer, selectReducer, addReducer, removeErrorReducer)

export const fetchClases = () => async (dispatch, getState) => {
    dispatch(fetchActions.start())
    try {
        const data = await leer('/clase')
        dispatch(fetchActions.success(data))
    } catch (error) {
        dispatch(fetchActions.error(error))
    }
}

export const editarClases = (id, values) => async (dispatch, getState) => {
    dispatch(editActions.start())
    try {
        const data = await modificar('/clase', id, values)
        dispatch(editActions.success(data))
    } catch (error) {
        dispatch(editActions.error(error))
    }
}

export const agregarClase = (values) => async (dispatch, getState) => {
    dispatch(addActions.start())
    try {
        const data = await crear('/clase', values)
        dispatch(addActions.success(data))
    } catch (error) {
        dispatch(addActions.error(error))
    }
}